import { Component, OnInit, ViewChildren, Inject, QueryList } from '@angular/core';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { AppServiceService } from 'src/app/services/app-service.service';
import { Router } from "@angular/router";
// import { MatPaginator } from '@angular/material/paginator';
// import { MatTableDataSource } from '@angular/material/table';
// import { MatSort, MatSortModule } from '@angular/material/sort'
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// import { MatSnackBar } from '@angular/material/snack-bar';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { GatewayService } from 'src/app/gateway.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'app-create-mensajeria',
  templateUrl: './create-mensajeria.component.html',
  // styleUrls: ['./create-mensajeria.component.scss']
  styles: [`[hidden] {display: none !important;} .mat-option{font-size:14px} .mat-raised-button[disabled] {box-shadow: none;color: white !important;border: transparent !important;background-color: #0780EE;background-color: rgba(0,0,0,.12) !important;} /deep/.mat-tab-body-content{overflow: hidden !important;}`]
})

// export class CreateMensajeriaComponent implements OnInit{
//   ngOnInit(): void {
//   }
// }

export class CreateMensajeriaComponent implements OnInit {
  options: any = [];
  lista;
  filteredOptions: Observable<string[]>;
  type;
  nuevoscriterios = [];
  valordisabled = true;
  loadingcreate = false;
  auxidmensajeria;
  errM: boolean = false;
  errM2: boolean = false;
  errMsg;
  vali = 0;
  vali1 = 0;
  paises;
  placeholderdescripcion: string = "Descripción";
  newfrecuencia = { DIA: '', HORA: '' };
  minDate = new Date();
  htmlText = ""
  hasFocus = false;
  listacampana : any = [];

  quillConfig = {
    "editable": true,
    "spellcheck": true,
    "height": "140px",
    "minHeight": "140px",
    "width": "auto",
    "minWidth": "0",
    "translate": "yes",
    "enableToolbar": true,
    "showToolbar": true,
    "imageEndPoint": "",
    "toolbar": [
      ["bold", "italic", "underline", "strikeThrough"],
      ["fontSize"],
      ["justifyLeft", "justifyCenter", "justifyRight", "justifyFull", "indent", "outdent"],
      ["removeFormat", "undo", "redo"],
      ["horizontalLine", "orderedList", "unorderedList"],
      ["link", "unlink"]
    ]
  };

  prueba: any = 5;

  public optionsFroala: Object = {
    charCounterCount: false,
    heightMin: 180,
    heightMax: 180,
    width: '95%',
    toolbarSticky: false,
    //imageEditButtons: ['imageAlign', '|', 'imageDisplay', 'imageStyle', 'imageReplace', 'imageSize'],
    toolbarButtons: ['undo', 'redo', '|', 'bold', 'italic', 'underline', 'fontSize', 'align', 'outdent', 'indent', 'formatOL', 'formatUL', 'clearFormatting'],
    toolbarButtonsMD: ['undo', 'redo', '|', 'bold', 'italic', 'underline', 'fontSize', 'align', 'outdent', 'indent', 'formatOL', 'formatUL', 'clearFormatting'],
    toolbarButtonsXS: ['undo', 'redo', '|', 'bold', 'italic', 'underline', 'fontSize', 'align', 'outdent', 'indent', 'formatOL', 'formatUL', 'clearFormatting'],
    toolbarButtonsSM: ['undo', 'redo', '|', 'bold', 'italic', 'underline', 'fontSize', 'align', 'outdent', 'indent', 'formatOL', 'formatUL', 'clearFormatting']
  }

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '140px',
    minHeight: '0',
    maxHeight: 'auto',
    width: '700px',
    minWidth: '0',
    placeholder: 'Ingrese aqui su mensaje...',
    translate: 'no',
    sanitize: false,
    // toolbarPosition: 'top',
    // outline: true,
    defaultFontName: 'Comic Sans MS',
    defaultFontSize: '5',
    // showToolbar: false,
    defaultParagraphSeparator: 'p',
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ]
  };

  ngOnInit() {

  }

  /////////////////////////////////////////FORMULARIO/////////////////////////////////////////////////////////
  fValidaciones = new FormGroup({
    NOMBRE: new FormControl('', Validators.required),
    ASUNTO: new FormControl('', Validators.required),
    CAMPANA: new FormControl('', Validators.required),
    PAIS: new FormControl(5, Validators.required),
    TIPO: new FormControl('', Validators.required),
    DESCRIPCION: new FormControl('', Validators.required),

    COBI: new FormControl(''),
    CONDICION: new FormControl(''),
    VALOR: new FormControl(''),
    CONSERVAR: new FormControl(''),
    FERIADO: new FormControl(''),
    OPTEXT: new FormControl(''),

    DIAFRECUENCIA: new FormControl('', Validators.required),
    OPNUMN: new FormControl('', Validators.required),
    OPEMAIL: new FormControl('', [Validators.required, Validators.pattern("[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]),
    OPCION: new FormControl('', Validators.required),
    OPNUMP: new FormControl('', [Validators.required, Validators.min(0)]),
    OPNUMF: new FormControl('', Validators.required),
    HORAFRECUENCIA: new FormControl('', [Validators.required, Validators.min(8), Validators.max(18), Validators.pattern("[0-9]{1,2}")])
  });
  /////////////////////////////////////////FORMULARIO/////////////////////////////////////////////////////////

  constructor(
    public dialogRef: MatDialogRef<CreateMensajeriaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private Service: AppServiceService,
    private localSave: LocalSaveService,
    // private snackbar: MatSnackBar,
    private gateway: GatewayService,) {
    // console.log(this.data.mensajeria);
    this.auxidmensajeria = this.data.mensajeria.idmensajeria;
    this.htmlText = this.data.mensajeria.descripcion;
    if (this.data.mensajeria.condicion) {
      this.data.mensajeria.condicion.map((e) => {
        this.nuevoscriterios.push(e);
      });
      this.gateway.get('getcriteriocatalogo', { IDPAIS: this.data.mensajeria.pais }).then((result) => {
        // console.log(result);
        this.options = result;
        this.filteredOptions = this.fValidaciones.controls.COBI.valueChanges
          .pipe(
            startWith<string | any>(''),
            map(value => typeof value === 'string' ? value : value.alias),
            map(alias => alias ? this._filter(alias) : this.options.slice())
          );
        this.fValidaciones.controls.COBI.enable();
      }).catch((error) => {
      });
    } else {

      this.fValidaciones.controls.COBI.disable();
      this.fValidaciones.controls.OPTEXT.disable();
      this.fValidaciones.controls.CONDICION.disable();
    }

    this.gateway.get('getcriteriocatalogo', { IDPAIS: this.data.mensajeria.pais }).then((result) => {
      // console.log(result);
      this.options = result;
      // console.log(this.options)
      this.filteredOptions = this.fValidaciones.controls.COBI.valueChanges
        .pipe(
          startWith<string | any>(''),
          map(value => typeof value === 'string' ? value : value.alias),
          map(alias => alias ? this._filter(alias) : this.options.slice())
        );
      this.fValidaciones.controls.COBI.enable();
    }).catch((error) => {
    });

    this.gateway.get('getlistacampana', { IDPAIS: this.data.mensajeria.pais, IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').IDU }).then((result) => {
      // console.log(result);
      this.listacampana = result;
    }).catch((error) => {
    });
  }

  displayFn(user?: any): string | undefined {
    return user ? user.ALIAS : undefined;
  }

  _filter(value: string): any {
    // console.log('value: ', value)
    const filterValue = value.toLowerCase();
    return this.options.filter(option => option.alias.toLowerCase().indexOf(filterValue) === 0);
  }

  getErrorMessage(x: any) {
    if (x == 1) {
      return this.fValidaciones.controls.NOMBRE.hasError('required') ? '* Ingresa un nombre' : '';
    } else if (x == 1.1) {
      return this.fValidaciones.controls.ASUNTO.hasError('required') ? '* Ingresa un asunto' : '';
    }else if (x == 2) {
      return this.fValidaciones.controls.PAIS.hasError('required') ? '* Selecciona un país' : '';
    } else if (x == 3) {
      return this.fValidaciones.controls.TIPO.hasError('required') ? '* Selecciona un tipo' : '';
    }else if (x == 3.1) {
      return this.fValidaciones.controls.CAMPANA.hasError('required') ? '* Selecciona una campaña' : '';
    } else if (x == 4) {
      return this.fValidaciones.controls.DESCRIPCION.hasError('required') ? '* Ingresa una descripción' : this.fValidaciones.controls.DESCRIPCION.hasError('maxlength') && this.data.mensajeria.tipo != 6 ? '* Sobrepasaste el límite de caracteres' : '';
    } else if (x == 5) {
      // console.log((this.fValidaciones.controls.COBI.hasError('required') || this.data.mensajeria.columnabi.COLUMN_NAME == '' ||  this.data.mensajeria.columnabi.COLUMN_NAME == "") ? '* Selecciona una columna' : '');
      return (this.fValidaciones.controls.COBI.hasError('required') || this.data.mensajeria.columnabi.column_name == '' || this.data.mensajeria.columnabi.column_name == "") ? '* Selecciona una columna' : '';
    } else if (x == 6) {
      return this.fValidaciones.controls.CONDICION.hasError('required') ? '* Selecciona una' : '';
    } else if (x == 7) {
      return this.fValidaciones.controls.CONDICION.hasError('required') ? '* Ingresar un valor' : '';
    } else if (x == 8) {
      return this.fValidaciones.controls.OPCION.hasError('required') ? '* Selecciona una' : '';
    } else if (x == 9) {
      return this.fValidaciones.controls.DIAFRECUENCIA.hasError('required') ? '* Selecciona uno o más' : '';
    } else if (x == 10) {
      return this.fValidaciones.controls.HORAFRECUENCIA.hasError('required') ? '* Ingresar una hora' : '';
    } else if (x == 11) {
      return this.fValidaciones.controls.OPTEXT.hasError('required') ? '* Ingresar un texto' : '';
    } else if (x == 12) {
      return this.fValidaciones.controls.OPNUMN.hasError('required') ? '* Ingresa un número' : '';
    } else if (x == 13) {
      return this.fValidaciones.controls.OPNUMP.hasError('required') ? '* Ingresa un número positivo' : '';
    } else if (x == 14) {
      return (this.fValidaciones.controls.OPEMAIL.hasError('required') || (this.fValidaciones.controls.OPEMAIL.hasError('pattern'))) ? '* Ingresa un correo válido' : '';
    }

  }

  importarHtml() {
    document.getElementById("input_upload").click();
    // this.loadingcreate = true;
  }

  async leerHtml(event) {
    const file: File = event.target.files[0];
    // this.loadingcreate = false;
    if (file) {
      const fr = new FileReader();
      fr.onload = function (e) {
        getTexto(fr.result.toString());
      };
      // fr.readAsText(file, 'ISO-8859-4');
      fr.readAsText(file);
    }
    const getTexto = (texto) => {
      this.htmlText = texto;
      this.data.mensajeria.descripcion = texto;
    }
  }

  selectpais(): void {
    // this.Service.getcriteriocatalogo({IDPAIS:this.data.mensajeria.pais}).subscribe(
    //   result => {
    //           // console.log(result);
    //           this.options = result;
    //           this.filteredOptions = this.fValidaciones.controls.COBI.valueChanges
    //           .pipe(
    //             startWith<string | any>(''),
    //             map(value => typeof value === 'string' ? value : value.ALIAS),
    //             map(ALIAS => ALIAS ? this._filter(ALIAS) : this.options.slice())
    //           );
    //           this.fValidaciones.controls.COBI.enable();
    //       },
    //   error => {
    //        if(error.status == 405 || error.status == 401){
    //               this.localSave.delete('user');
    //             this.router.navigate(['login']);
    //           }
    //   }
    // );
  }

  selectcolumna() {
    this.errM = false;
    if (this.data.mensajeria.columnabi.tipo == 2) {
      // console.log('data.mensajeria.columnabi')
      // console.log(this.data.mensajeria.columnabi);
      this.gateway.get('getcriteriolista', { TABLA: this.data.mensajeria.columnabi.tabla, IDPAIS: this.data.mensajeria.pais }).then((result) => {
        // console.log(result);
        this.lista = result;
        this.valordisabled = false;
        this.fValidaciones.controls.CONDICION.enable();
        this.fValidaciones.controls.OPTEXT.enable();
        // console.log('getcriteriolista <<<<<<<<<<')
        // console.log(result);
      }).catch((error) => {
      });
    } else {
      this.valordisabled = false;
      this.fValidaciones.controls.CONDICION.enable();
      this.fValidaciones.controls.OPTEXT.enable();
    }
  }

  selecttipo(): void {

    if (this.data.mensajeria.tipo == 0) {
      this.placeholderdescripcion = 'Beneficio';
    } else if (this.data.mensajeria.tipo == 1 || this.data.mensajeria.tipo == 3 || this.data.mensajeria.tipo == 4 || this.data.mensajeria.tipo == 5) {
      this.placeholderdescripcion = 'Mensaje';
    } else if (this.data.mensajeria.tipo == 2) {
      this.placeholderdescripcion = 'Script';
    }

    if (this.data.mensajeria.tipo == 6) {
      this.fValidaciones.controls["DESCRIPCION"].setValidators([Validators.required, Validators.maxLength(20000)]);
      this.fValidaciones.controls["DESCRIPCION"].updateValueAndValidity();
    } else {
      this.fValidaciones.controls["DESCRIPCION"].setValidators([Validators.required, Validators.maxLength(160)]);
      this.fValidaciones.controls["DESCRIPCION"].updateValueAndValidity();
    }

  }

  cleancriterio() {
    // console.log('nuevos criterios');
    // console.log(this.nuevoscriterios);
    // console.log('nuevos criterios');

    this.data.nuevocriterio = {
      'NOMBRE': '',
      'ASUNTO': '',
      'PAIS': '',
      'TIPO': '',
      'DESCRIPCION': '',
      'columnabi': { COLUMN_NAME: '', IDCATALOGO_CRITERIO: 0, ORDEN: 0, TABLA: '', TIPO: 0 },
      'CONDICION': '',
      'VALORALFANUMERICO': '',
      'CONSERVAR': 0,
      'VALORLISTADO': []
    };
  }

  remove(indice) {
    this.nuevoscriterios.splice(indice, 1);
  }

  removefrecuencia(indice) {
    this.data.mensajeria.frecuencias.splice(indice, 1);
  }

  addcriterio() {
    if (this.data.mensajeria.columnabi.tipo || this.data.mensajeria.columnabi.tipo == 0) {
      if (this.nuevoscriterios.length > 0) {
        if (this.data.mensajeria.columnabi.tipo == 2) {
          // this.data.mensajeria.VALORLISTADO.map((e)=>{
          let temp = {
            IDCATALOGO_CRITERIO: this.data.mensajeria.columnabi,
            CONDICION: this.data.mensajeria.condicion,
            VALOR: this.data.mensajeria.valorlistado,
            TIPO: this.data.mensajeria.columnabi.tipo
          };
          this.vali = 0;
          this.nuevoscriterios.forEach((crit) => {
            // if(JSON.stringify(crit) == JSON.stringify(temp)){
            if (crit.IDCATALOGO_CRITERIO.COLUMN_NAME == temp.IDCATALOGO_CRITERIO.COLUMN_NAME) {
              // console.log('true');
              this.vali = this.vali + 1;
            } else {
              // console.log('false');
            }
            // console.log(this.vali);
          });
          this.vali = 0;
          if (this.vali == 0) {
            this.errM = false;
            this.nuevoscriterios.push(temp);
          } else {
            this.errMsg = { error: { msg: '* Valor duplicado.' } };
            this.errM = true;
          };

          // });
          this.cleancriterio();

        } else {
          let temp1 = {
            IDCATALOGO_CRITERIO: this.data.mensajeria.columnabi,
            CONDICION: this.data.mensajeria.condicion,
            VALOR: this.data.mensajeria.valoralfanumerico,
            TIPO: this.data.mensajeria.columnabi.tipo
          };
          this.vali1 = 0;
          this.nuevoscriterios.forEach((crite) => {
            // if(JSON.stringify(crite) == JSON.stringify(temp1)){
            if (crite.IDCATALOGO_CRITERIO.COLUMN_NAME == temp1.IDCATALOGO_CRITERIO.COLUMN_NAME) {
              // console.log('true');
              this.vali1 = this.vali1 + 1;
            } else {
              // console.log('false');
            }
            // console.log(this.vali1);
          })
          this.vali1 = 0;
          if (this.vali1 == 0) {
            this.errM = false;
            this.nuevoscriterios.push(temp1);
            this.cleancriterio();
          } else {
            this.errMsg = { error: { msg: '* Valor duplicado.' } };
            this.errM = true;
          };

        }
      } else {

        // console.log(this.data.mensajeria);
        if (this.data.mensajeria.columnabi.tipo == 2) {
          // this.data.mensajeria.VALORLISTADO.map((e)=>{
          this.nuevoscriterios.push({
            IDCATALOGO_CRITERIO: this.data.mensajeria.columnabi,
            CONDICION: this.data.mensajeria.condicion,
            VALOR: this.data.mensajeria.valorlistado,
            TIPO: this.data.mensajeria.columnabi.tipo
          });
          // });
          this.cleancriterio();
        } else {
          this.nuevoscriterios.push({
            IDCATALOGO_CRITERIO: this.data.mensajeria.columnabi,
            CONDICION: this.data.mensajeria.condicion,
            VALOR: this.data.mensajeria.valoralfanumerico,
            TIPO: this.data.mensajeria.columnabi.tipo
          });
          this.cleancriterio();
        }
      }
    } else {
      this.data.mensajeria.columnabi = { column_name: '', idcatalogo_criterio: 0, orden: 0, tabla: '', tipo: 0 };
    }

  }
  cancelcriterio() {
    this.cleancriterio();
    this.dialogRef.close();
  }

  addfrecuencia() {
    let validate = true;
    this.errM = false;
    const d = new Date(this.newfrecuencia.DIA)
    // console.log(this.newfrecuencia.DIA)
    // console.log(d)
    // console.log(d.getDate())
    // console.log(d.getMonth()+1)
    // console.log(d.getFullYear())

    const fecha = d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear()

    //this.newfrecuencia.DIA.map((e)=>{
    this.data.mensajeria.frecuencias.map((comparar) => {
      let auxinsert = { DIA: fecha, HORA: this.newfrecuencia.HORA };
      if (JSON.stringify(comparar) == JSON.stringify(auxinsert)) { validate = false; }
    });
    // });

    if (validate) {
      // this.newfrecuencia.DIA.map((e)=>{
      this.data.mensajeria.frecuencias.push({ DIA: fecha, HORA: this.newfrecuencia.HORA });
      // }
      // );
    } else {
      this.errMsg = { error: { msg: 'No se permiten valores duplicados' } };
      this.errM = true;
    }

  }

  createmensajeria() {
    this.loadingcreate = true;
    let sendcriterio = {
      IDMENSAJERIA: this.auxidmensajeria,
      TIPO: this.data.mensajeria.tipo,
      IDPAIS: this.data.mensajeria.pais,
      NOMBRE: this.data.mensajeria.nombre,
      ASUNTO: this.data.mensajeria.asunto,
      DESCRIPCION: this.data.mensajeria.descripcion,
      CONDICIONES: this.nuevoscriterios,
      CONSERVAR: this.data.mensajeria.conservar,
      FERIADO: this.data.mensajeria.feriado,
      FRECUENCIAS: this.data.mensajeria.frecuencias,
      HTML: this.htmlText,
      IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').IDU,
      IDCAMPANA: this.data.mensajeria.idcampana
    };

    // console.log(this.htmlText)
    // console.log(this.data.mensajeria.tipo)

    if (this.data.mensajeria.tipo == 6) {
      sendcriterio.DESCRIPCION = this.htmlText;
    }

    this.gateway.get('upsertmensajeria', sendcriterio).then((result) => {
      this.auxidmensajeria = '';
      this.loadingcreate = false;
      if(!result['msg']){

      }else{
        this.data.mensajeria = {
          'idmensajeria': '',
          'nombre': '',
          'asunto': '',
          'pais': '',
          'tipo': '',
          'descripcion': '',
          'columnabi': { column_name: '', idcatalogo_criterio: 0, orden: 0, tabla: '', tipo: 0 },
          'condicion': '',
          'valoralfanumerico': '',
          'valorlistado': [],
          'frecuencias': [],
          'conservar': 0,
          'feriado': 0
        };
        this.dialogRef.close();
      }
      
    }).catch((error) => {
    });

    
  }

}

